import { useEffect } from "react";
import { FiX } from "react-icons/fi";
import PostComments from "./PostComments";
import "./postModal.css";

export default function PostCommentsModal({
  post,
  currentUser,
  onClose,
  onCommentAdded,
}) {

  /* ================= BODY SCROLL LOCK ================= */

  useEffect(() => {

    if (!post) return;

    document.body.style.overflow = "hidden";

    const handleEsc = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };

    window.addEventListener("keydown", handleEsc);

    return () => {
      document.body.style.overflow = "auto";
      window.removeEventListener("keydown", handleEsc);
    };

  }, [post, onClose]);

  /* ================= SAFETY RETURN ================= */

  if (!post) return null;

  /* ================= RENDER ================= */

  return (
    <div
      className="comment-modal-overlay"
      onClick={onClose}
    >
      <div
        className="comment-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <h3>Comments</h3>
          <FiX className="close-btn" onClick={onClose} />
        </div>

        <div className="modal-body">

          {post.media?.url && (
            <div className="modal-image">
              <img src={post.media.url} alt="post" />
            </div>
          )}

          <div className="modal-comments">
            <PostComments
              postId={post._id}
              currentUser={currentUser}
              onCommentAdded={onCommentAdded}
            />
          </div>

        </div>
      </div>
    </div>
  );
}
